module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/F000E.jpg"
    }
  }), _vm._v("spen’s tires crunched on the gravel of the driveway into the fox farm. He glanced around for the glint of eyes. Did the foxes just run around loose? He wasn’t sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two empty milk bottles on the front porch, Mr. Henriksen had said, was the sign that it was safe to go inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The house was filled with heaven: the fragrance of waffles cooking on a griddle. Espen’s glasses steamed up immediately, and he took them off to clean them. When he put them back on, he saw first a head of red hair and then the rest of the small, round woman who had appeared from the kitchen door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you followed?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen shook his head. “I was stopped, though,” he said. “They searched my backpack.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really!” she said. “And …?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There was nothing in it except, um, jelly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good boy,” she said. She brushed a wisp of hair away, then held out her hand. “Nice to meet you. Call me ‘Tante Marie.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Espen shook her hand and said, “My name is—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ssst!” she hissed. “Your code name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have one,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, we’ll have to fix that!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A code name!")]), _vm._v(" Espen thought. His stomach buzzed a little with excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, then, give me what you brought,” Tante Marie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen reached down and slid the folded papers from one of his long woolen stockings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Clever boy!” she said. “Now, come in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen stepped into the kitchen, where he couldn’t help but notice the steam rising from a waffle griddle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s just about growing potatoes in your garden,” Espen said, watching her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tante Marie cocked an eyebrow, then smiled. “OK,” she said, “you know it’s more than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still,” he said, “it’s only news!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tante Marie sucked in her breath with an inward “"), _c('em', [_vm._v("Ja")]), _vm._v("” as she perused the paper. “Did you ever think that ‘only news’ would get to be so precious?” She clucked her tongue as she read aloud the main points of the stories: “Reichskommissar Terboven has ‘deposed’ the king and the government and dissolved all political parties but the Nazi party … Norwegian Nazi storm troopers attacked and beat up a teacher and his students at a school in Oslo … In Trondheim, a student was beaten because he wouldn’t put up a poster for "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("the Nazis … Let’s see,” she went on. “Our well-respected Dr. Scharffenberg addressed the university students recently. He said, ‘Let the Nazis know that Norway’s youth will defend freedom and independence no matter the cost to us all.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen cleared his throat. “I would … I could do something to help,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tante Marie’s eyes flickered over him like small blue flames. “What do you propose?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever is needed,” he replied. “I could do it. I’m quite fit. I can bicycle quite fast, if need be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tante Marie pursed her lips and said, “Well … sit down here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat at the table in front of a platter heaped with—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Waffles!” Espen exclaimed. “I must be dreaming!” He glanced around but didn’t see anyone else. “All for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed. “Have you been a good boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm …” Espen remembered that he had swiped the jelly from his mother’s pantry. “Not especially.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She clucked her tongue but put a couple of waffles onto a plate and slid it toward him. “"), _c('em', [_vm._v("Vær så god")]), _vm._v(",” she said. “Help yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He marveled at the food for a moment. “Where did you get eggs?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know some hens,” Tante Marie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have some jelly!” Espen took the jar out of his rucksack and snapped off the lid. He hadn’t realized it would "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("come in so handy, and he was glad his uncle was not really expecting him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tried to be polite about the waffles but couldn’t help himself and took an enormous mouthful. They were so warm, sweet, and delicious, he thought he might cry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know that every part we play in the underground, no matter how small it seems, is significant,” Tante Marie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, ma’am,” Espen said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And every part helps the rest. The Resistance has gotten quite organized now. There’s Milorg, the military branch, and Civorg, the civilian branch, which is responsible for newspapers and propaganda, and there’s XU.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“XU?” Espen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Intelligence,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean, like, spying?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("Ja")]), _vm._v(",” she said. “Each part is important. No part can exist without the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen stopped chewing for a moment. "), _c('em', [_vm._v("Spying!")]), _vm._v(" That’s what he would like to do. That would be it, exactly! “My friend and I have done quite a bit of spying already,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you brave enough to continue delivering newspapers?” Tante Marie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen snorted. “A few little pages like these? You don’t have to be so brave to do that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He felt the heat of her eyes on him. “These ‘little’ newspapers,” she said, “are illegal. They tell the truth about the "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("Nazis. You are aware that anything that criticizes the Nazis is forbidden? Just to "), _c('em', [_vm._v("read")]), _vm._v(" a different point of view than their own—they can arrest you for that! Not to scare you or anything,” she added offhandedly. “Now, what do you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen nodded. “I can do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The griddle steamed, and Tante Marie plucked a waffle out of it. She glanced at the newspaper again. “They’ve abolished the oath of silence of the clergy,” she said. “The Nazis can demand the names of church members who oppose the Occupation or the names of Jews who have converted to Christianity. And if the clergy refuses? Imprisonment! What do they want with that list, do you suppose? Why do they need to know who the anti-Nazis are? Who the Jews are?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t hard to get Tante Marie going, Espen thought. If she stayed distracted long enough, he could nab another waffle without her noticing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those Nazis are like a troll with many heads.” Tante Marie whapped more batter onto the griddle. “And those heads need to be chopped off”—she slammed the lid down—“one at a time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I assume you mean that as a …” Espen tried to remember the word they had learned in literature class. “Metaphor,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes a metaphor is the truest thing there is,” Tante Marie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She continued talking, and Espen tried to listen, but he "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("couldn’t think about anything except waffles and, when the ones on his plate were finished, more waffles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“… but a clever boy,” she was saying, “can outwit them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen slid his hand across the table toward the platter. “I’m not clever at all,” he said. “You know, the other boys say I’m so foolish, I forget to pull my head in before I shut the window.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned and lightly slapped his hand with the back of her spatula.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See?” he said. “I can’t even steal a waffle without you noticing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you can’t expect to outwit "), _c('em', [_vm._v("me")]), _vm._v(",” she said. “But a troll is a different matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He watched as she picked up the entire plate of waffles, placed it in a pail, and covered it with a cloth. She was still talking. She had moved on to Norse mythology, and he tried to pay attention, but all he could think about was what the fate of all that deliciousness was going to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“… you know the one I’m talking about,” she was saying. “Not the Odin Swensen who works in the hardware store—I’m talking about Odin, the Norse god, the all-seeing god. But being all-seeing wasn’t good enough for him, was it? He also wanted to be all-wise. So he went to see Mimir, who was the keeper of the Well of Wisdom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen wished he’d been paying attention, so he’d know why she was talking about this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Tante Marie continued with her story. “Odin said to Mimir, ‘I want to know what you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Mimir said, ‘OK, but it will cost you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“‘Fine,’ Odin said. ‘What will it cost?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“‘Your left eye,’ said Mimir.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Without hesitation, Odin plucked out his left eye and threw it into the well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“‘Now, tell me how to be as all-wise as you are,’ Odin said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“‘The answer,’ Mimir said, ‘"), _c('em', [_vm._v("is to watch with both eyes!")]), _vm._v("’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tante Marie winked at Espen, then handed him the pail full of waffles. “Now, take this out to the barn.” She shooed him toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re feeding these to the foxes?” he squeaked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is possible to know too much,” Tante Marie said. “Didn’t I just tell you that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Espen walked to the barn slowly, wondering if Tante Marie was a little nutty. He didn’t remember her warning him about knowing too much. He wondered how many waffles he could eat before he got to the barn. And did foxes even eat waffles? Didn’t they eat mice and rabbits and things like that? Espen slipped his hand under the cloth and pulled out a still-warm waffle. Would the foxes pounce on him when he entered? What if they bit? And since when did foxes need a barn?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took a bite of waffle and stepped cautiously into the darkness of the barn. It was so quiet, he stopped chewing. "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("Then the silence was broken by the whisper-soft sound of rustling straw and a startling, raspy cough that sounded not at all like one a fox would make. He swallowed his bite of waffle, which felt as dry as a wad of cotton. Then he set the pail down and slipped out quickly, before his eyes had a chance to adjust to the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Espen could coast home. It was all downhill. He wasn’t carrying anything incriminating, not even the jelly. He’d left it with Tante Marie in exchange for some eggs. "), _c('em', [_vm._v("Mor")]), _vm._v(" would be so pleased. He would have to make up a story about how he came by them and about what had happened to the jelly, which she probably wouldn’t believe anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He should have been able to relax, but he was trembling so much that his teeth were chattering, and not because he was cold. He was excited. He stopped and switched off his bike light. The moon had emerged from behind the jagged ridge; it was as bright and all-seeing as Odin’s single eye, and it lit up the mountains, making them seem as big and fierce as frost giants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was going on in those mountains tonight? Espen wondered. He knew there were men and even boys hiding there. They had evaded capture or had escaped from Nazi prisons or were working for the Resistance from mountain huts. In the next valley over perhaps there was another boy, riding his bicycle along another lonely road. Up in the "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("mountains a girl might be skiing a snowy trail. In the big city, boys walked down cobbled streets, delivering newspapers, many of them. On bicycles or skis, on foot, in row-boats, stopping by lonely farms, town houses, apartment buildings, and in sleepy fishing villages—all over Norway people were planning and plotting and doing. Now he was one of them. He had joined the Resistance. Soon, Tante Marie had said, he would have an assignment. And he had a code name: Odin.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 87
// module chunks = 0